import TextInputBox from '@components/TextInputBox';

import { withDelayedSearch } from './withDelayedSearch';

export const DelayedSearchTextInput = withDelayedSearch(TextInputBox);
